import React, { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import ReRegistrationVocationalTrainingForm, { ReRegistrationVocationalTrainingFormItem } from "../../../../forms/recadastramento/ReRegistrationVocationalTrainingForm";

import AcademicService from "../../../../services/AcademicService";
import TmpInputSelectSearchCustom from "../../../../components/tempo/TmpInputSelectSearchCustom/TmpInputSelectSearchCustom";
import TmpDatepickerCustom from "../../../../components/tempo/TmpDatepickerCustom/TmpDatepickerCustom";
import TmpInputCustom, { InputMaskProps } from "../../../../components/tempo/TmpInputCustom/TmpInputCustom";
import TmpTableBaseCustom, { ITableColumnsProps } from "../../../../components/tempo/TmpTableBaseCustom/TmpTableBaseCustom";
import TmpButtonCustom from "../../../../components/tempo/TmpButtonCustom/TmpButtonCustom";


interface ReRegistrationVocationalTraningComponentProps {
    ReRegistrationVocationalTrainingForm: ReRegistrationVocationalTrainingForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: ReRegistrationVocationalTrainingFormItem) => void
    onDeleteClick: (e: ReRegistrationVocationalTrainingFormItem) => void
    onCancelItem: () => void
}

export default function ReRegistrationVocationalTraningComponent(props: ReRegistrationVocationalTraningComponentProps) {

    const headers: ITableColumnsProps[] = [
        { title: "Especialidade", align: "center", property: "Expertise", type: "text" },
        { title: "Data de Obtenção", align: "center", property: "DateAcquisition", type: "date" },
        { title: "Número RQE", align: "center", property: "NumberRQE", type: "text" },
    ]

    const [specialtyStateOptions, setSpecialtyStateOptions] = useState([])

    useEffect(() => {
        AcademicService.getAllSpecialtyOptions().then(e => setSpecialtyStateOptions(e))
    }, []);


    return (

        <Grid container spacing={3}>
            <Grid item xs={5} sm={5}>
                <TmpInputSelectSearchCustom
                    label="Especialidade *"
                    name="Expertise"
                    id="Expertise"
                    placeholder="Selecione"
                    itens={specialtyStateOptions}
                    value={props.ReRegistrationVocationalTrainingForm.Expertise.Value}
                    onChange={(e) => { props.onInputChange("Expertise", props.ReRegistrationVocationalTrainingForm, e.target.value); }}
                    onBlur={(e) => { props.onInputChange("Expertise", props.ReRegistrationVocationalTrainingForm, e.target.value); }}
                    error={props.ReRegistrationVocationalTrainingForm.Expertise.HasError()}
                    helperText={props.ReRegistrationVocationalTrainingForm.Expertise.Error}
                />
            </Grid>

            <Grid item xs={3} sm={3}>
                <TmpDatepickerCustom
                    name="DateAcquisition"
                    label="Data de obtenção *"
                    value={props.ReRegistrationVocationalTrainingForm.DateAcquisition.Value}
                    placeholder="Data de obtenção *"
                    onChange={(e) => { props.onInputChange("DateAcquisition", props.ReRegistrationVocationalTrainingForm, e.target.value); }}
                    onBlur={(e) => { props.onInputChange("DateAcquisition", props.ReRegistrationVocationalTrainingForm, e.target.value); }}
                    error={props.ReRegistrationVocationalTrainingForm.DateAcquisition.HasError()}
                    helperText={props.ReRegistrationVocationalTrainingForm.DateAcquisition.Error}
                />
            </Grid>

            <Grid item xs={4} sm={4}>
                <TmpInputCustom
                    id="NumberRQE"
                    name="NumberRQE"
                    label="Número RQE"
                    maxLength={12}
                    type="text"
                    mask={InputMaskProps.NUMERICO}
                    placeholder="Digite o número RQE"
                    value={props.ReRegistrationVocationalTrainingForm.NumberRQE.Value}
                    onChange={(e) => {
                        props.onInputChange("NumberRQE", props.ReRegistrationVocationalTrainingForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("NumberRQE", props.ReRegistrationVocationalTrainingForm, e.target.value);
                    }}
                    error={props.ReRegistrationVocationalTrainingForm.NumberRQE.HasError()}
                    helperText={props.ReRegistrationVocationalTrainingForm.NumberRQE.Error}
                />
            </Grid>



            <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                    {(props.ReRegistrationVocationalTrainingForm.FormItemToEdit.Id > 0 ?
                        <TmpButtonCustom id={"cancelar"} type="secondary" typeButton="button" size="sm" handleClick={props.onCancelItem}>
                            Cancelar edição formação profissional
                        </TmpButtonCustom>
                        : null
                    )}

                    {(props.ReRegistrationVocationalTrainingForm.FormItemToEdit.Id === 0 ?
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Adicionar formação profissional
                        </TmpButtonCustom>
                        :
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Salvar formação profissional
                        </TmpButtonCustom>
                    )}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <TmpTableBaseCustom
                    columns={headers}
                    actionEditColumn={true}
                    actionDeleteColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick}
                    rows={props.ReRegistrationVocationalTrainingForm.FormItemList}
                />
            </Grid>


        </Grid >

    )

}